import DataStore from './DataStore';
import Utils from '../common/Utils';
import Serverfilter from './components/Serverfilter';
import Classfilter from './components/Classfilter';
import Sortfilter from './components/Sortfilter';
import Getsearchresult from './components/Getsearchresult';

/**
 * character의 시작점
 * @category character
 * @memberof module:character
 * @param  {Object} _config={} 설정 옵션
 */
class App {
    constructor(_config = {}) {
        this.tabMenu = null;
        this.store = new DataStore(_config);
        this.selector = '#container';
        this.classFilter = new Classfilter(this.store);
        this.serverFilter = new Serverfilter(this.store);
        this.sortFilter = new Sortfilter(this.store);
        this.getSearchResult = new Getsearchresult(this.store);


      if (window.ncui && window.ncui.autoSuggest) {
        new ncui.autoSuggest({
          apiUrl: 'https://api-search.plaync.com/bns/search/v2/character/suggest',
          addParam: {}, // api 에 추가로 붙여서 보낼 파람이 있을경우
          selector : '#bnsAutoSuggest', // 검색 form이 삽입될 컨테이너 selector
          size: 10, // 자동완성 리스트 갯수
          useDelbtn: true, // 검색어 삭제 버튼 활성화
          useRecent: true, // 최근검색어 목록 사용 여부
          cookieName: 'autosuggest', // 최근검색어가 저장될 쿠키의 키네임
          keywordParamName: 'keyword',
          placeholderStr: '캐릭터명을 입력해주세요.',
          useCookie: true, // 쿠키를 사용해도 되는지여부 (1.7.20 추가)
          submitCallback: (_q) => {
          }
        });
      }

      this.addEvents();
        //
        // let autoSuggest = new AutoSuggest();
        // autoSuggest.init({
        //     selector : '#autoSuggest',
        //     service: 'bns',
        //     alias: 'character',
        //     size: 10,
        //     useDelbtn: true,
        //     apiUrl: 'https://api-search.plaync.com/bns/search/v2/character/suggest',
        //     submitCallback: function(_q){
        //     }
        // });
    }

    addEvents(){
        $(document).ready(function() {
            $(".section-contents .loading-wrap").removeClass('is-show');
            let hashParameter = decodeURI(window.location.hash.replace('#', ''));
            if(hashParameter){
                if(window.location.href.includes('/charactersearch')){
                    $('.contents-wrapper').addClass('charactersearch');
                }
                $('.search-header [data-name=suggest_input]')[0].value = hashParameter;
                $('.search-header').addClass('is-show');
                $('.search-header [data-name=suggest_submit]').trigger('result_change');
            }
            else{
                $('.search-header').addClass('is-home-view');
            }
        });

        $(document).on('click', '.search-header [data-name=suggest_submit]', (e)=>{
            if(window.location.href.includes('/charactersearch')){
                $('.contents-wrapper').addClass('charactersearch');
            }
            $('.search-header').removeClass('is-home-view');
            $('.search-header').addClass('is-show');
            $('.search-header [data-name=suggest_submit]').trigger('result_change');

        });

        $('.search-header [data-name=suggest_input]').on('keydown', (e)=>{
            if (e.which === 13) {
                if(window.location.href.includes('/charactersearch')){
                    $('.contents-wrapper').addClass('charactersearch');
                }
                window.location.hash = '';
                $('.search-header').removeClass('is-home-view');
                $('.search-header').addClass('is-show');
                $('#select-sort').trigger('result_change');

            }
        });

        $(document).on('click', '.ui-paging-arrow', (e)=>{
            if($(e.currentTarget)[0].hasAttribute('disabled')){
                return false;
            }
            else{
                $(e.currentTarget).trigger('result_change', [$(e.currentTarget).attr('data-page-value')]);
            }
        });

        $(document).on('click', '.ui-paging-num', (e)=>{
            if(!$(e.currentTarget).attr('class').includes('is-active')){
                $(e.currentTarget).trigger('result_change', [$(e.currentTarget).attr('data-page-value')]);
            }
        });

        $(document).on('click', '.no-login-wrap .no-login-link', (e)=>{
            var returnurl = "?site_id=32&return_url=" + escape(document.location.href).replace('charactersearch','character');
            var loginURL;
            if(document.location.href.split('/')[2].includes('local')|| document.location.href.split('/')[2].includes('sb')){
                loginURL = 'https://login.sb.plaync.com/login/signin';
            }
            else if(document.location.href.split('/')[2].includes('rc') ){
                loginURL = 'https://'+document.location.href.substring(8,10)+'-mlogin.plaync.com/login/signin';
            }
            else{
                loginURL = 'https://mlogin.plaync.com/login/signin';
            }
            document.location.href = loginURL + returnurl;
            return false;
        });

        $(document).on('server_change', '#select-serverId', (e)=>{
            let serverType = $(e.currentTarget).children("option:selected").attr('data-server-type');
            this.classFilter.setting(serverType);
        });

        $(document).on('result_change', (_e, _pageValue)=>{
            let keyword = encodeURI($('.search-header [data-name=suggest_input]')[0].value);
            let serverId = $("#select-serverId").children("option:selected").attr('value');
            let serverType = $("#select-serverId").children("option:selected").attr('data-server-type');
            let classId = $("#select-classId").children("option:selected").attr('value');
            let sort = $("#select-sort").children("option:selected").attr('value');
            let page=1;
            if(_pageValue){
                page=_pageValue;
            }
            let size=20;
            let searchQuery = '?';

            if(keyword){
                searchQuery += 'keyword='+keyword;
            }
            else{
                searchQuery += 'keyword= ';
            }
            if(serverId){
                searchQuery += '&serverId='+serverId+'&serverType='+serverType;
            }
            if(classId){
                searchQuery += '&classId='+classId;
            }
            if(page) {
              searchQuery += '&page=' + page;
            }

            if(size){
                searchQuery += '&size='+size;
            }
            if(sort){
                searchQuery += '&sort='+sort;
            }
            //테스트
            //searchQuery += '&zone=qatest';
            this.getSearchResult.setting(searchQuery, this.store);
        });
    }
}

Utils.namespace('nc.bns.character');
nc.bns.character = App;

